export const MessageType = {
	ERROR: "ERROR",
	SUCCESS: "SUCCESS"
};
